import { render, staticRenderFns } from "./NavigationTemplate.vue?vue&type=template&id=89e7c354&scoped=true"
import script from "./NavigationTemplate.vue?vue&type=script&lang=ts"
export * from "./NavigationTemplate.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTemplate.vue?vue&type=style&index=0&id=89e7c354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e7c354",
  null
  
)

export default component.exports